import { OrderType } from "@multiweb/types/multiweb";
import { Event } from "../../../../Global/Base/Events";
import { IDataGrid } from "../../IDataGrid";
import { Column } from "../Columns/Column";
import { Cell } from "./Cell";
import { IDataRowElement } from "./IDataRow";

export class HeaderCell extends Cell {
    //#region Fields
    public static currentResizeCell: HeaderCell = undefined; // staticka promenna obsahjici aktualne resizujici prvek (viz. popis funkce window.onmouseup)
    public element: HTMLElement;
    private _visibility: boolean = true;

    private _isResizing: boolean = false;

    public initialResizeWidth: number;
    public initialResizeXaxis: number;
    /**nazev atributu v DB*/
    public attribute: string;
    //#endregion Fields

    //#region Events
    public resizing: Event<HeaderCell, MouseEvent> = new Event<HeaderCell, MouseEvent>();
    public resizingStart: Event<HeaderCell, MouseEvent> = new Event<HeaderCell, MouseEvent>();
    public resizingEnd: Event<HeaderCell, MouseEvent> = new Event<HeaderCell, MouseEvent>();
    public sorting: Event<HeaderCell, MouseEvent> = new Event<HeaderCell, MouseEvent>();
    //#endregion Events

    //#region Properties
    public get isResizing(): boolean {
        return this._isResizing;
    }

    public set isResizing(value: boolean) {
        this._isResizing = value;
    }

    public get visibility(): boolean {
        return this._visibility;
    }

    public set visibility(value: boolean) {
        this._visibility = value;

        if (this.element) {
            this.element.classList.toggle("invisible", !value);
            if (value) {
                this.element.style.display = "";
                this.element.classList.remove("no-sort-item");
            } else {
                this.element.style.display = "none";
                this.element.classList.add("no-sort-item");
            }
        }
    }

    public override set interactive(v: boolean) {
        super.interactive = v;

        if (this.element) {
            const list = this.element.getElementsByClassName("DropDownMenu_item");
            if (list.length > 0) {
                v ? (list[0] as HTMLElement).style.display = "" : (list[0] as HTMLElement).style.display = "none";
            }
        }
    }

    //#endregion Properties

    //#region Constructors
    constructor(owner: IDataGrid<IDataRowElement>, index: number, column: Column) {
        super(owner, index, column);

        column.headerCell = this;
    }
    //#endregion Constructors

    //#region Methods
    public override render(order?: OrderType): HTMLElement {
        this.element = this.column.headerTemplate.render(this.column, this._index);
        this.element.classList.add("HeaderCell");

        this.updateOrderType(order);

        this.element.style.display = this.visibility ? "" : "none";
        if (this.visibility)
            this.element.classList.remove("no-sort-item");
        else
            this.element.classList.add("no-sort-item");

        return this.element;
    }

    /**
     * Nastaví typ třídění na hlavičce sloupce
     * @param order - Aktuální typ třídění (žádné když prázdný)
     */
    public updateOrderType(order?: OrderType): void {
        if (this.element == undefined) {
            this.element = this.column.headerTemplate.render(this.column, this._index);
            this.element.classList.add("HeaderCell");
        }

        this.element.classList.remove("TableHeadOrdered", "TableHeadOrderedDESC");

        if (order == null) {
            this.element.removeAttribute("order");
        } else if (order === OrderType.ascending) {
            this.element.classList.add("TableHeadOrdered");
            this.element.setAttribute("order", "1");
        } else if (order === OrderType.descending) {
            this.element.classList.add("TableHeadOrderedDESC");
            this.element.setAttribute("order", "2");
        }
    }
    //#endregion Methods

    //#region dispose
    /**
     * Destruktor
     */
    public override dispose(): void {
        this.resizing.removeAll();
        this.resizingStart.removeAll();
        this.resizingEnd.removeAll();
        this.sorting.removeAll();

        super.dispose();
    }

    //#endregion dispose
}
